import { render, staticRenderFns } from "./moves_content.vue?vue&type=template&id=23681a47&"
import script from "./moves_content.vue?vue&type=script&lang=js&"
export * from "./moves_content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports